@use "~theme/typography";
@use "~components/TextInput/tokens" as TextInput;

.container {
  margin-top: 4px;
  margin-bottom: 8px;
}

.label {
  @include typography.field-label;
}

.textAreaContainer {
  position: relative;
}

.textArea {
  @include typography.body;
  background-color: var(--gray-04);
  border: 1px solid var(--blue-01-at-30);
  border-radius: 2px;
  color: var(--black);
  font-weight: normal;
  padding: 9px;
  width: 100%;

  &::placeholder {
    color: var(--black-at-75);
    opacity: 1;
  }

  &:valid {
    border-color: var(--blue-01-at-30);
  }

  &:focus {
    outline: none;
    border-color: var(--blue-01);
  }
}

.errorMessage {
  @include TextInput.error-message;
}

.error {
  border-color: var(--red);
  box-shadow: inset 0 0 0 4px var(--red-at-50);
}
